<template>
  <div class="page-signed">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">送貨上門</div>
      <div class="breadcrumb-item">送貨上門(已簽收)</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select size="small" placeholder="提貨櫃點" v-model="form.arrive" clearable>
            <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                    :key="item.ReceivingID">{{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select size="small" placeholder="付款狀況" v-model="form.pay_type" ref="resetSelect" clearable>
            <Option value="0">未在APP內付款</Option>
            <Option value="1">已在APP內付款</Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="起始日期"
                      value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false"
                      v-model="form.start_time"></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="結束日期"
                      value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false"
                      v-model="form.end_time"></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">模糊搜索(電話號碼/用戶名/單號)</label>
          <Input size="small" clearable v-model="form.username" @keyup.enter.native="handleSearch()" clearable></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">手機號碼</label>
          <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">袋號</label>
          <Input size="small" clearable v-model="form.sack_number" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <!-- <div class="pg-btn style2" @click="handleExport">導出excel</div> -->
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
      <Table ref="table"
             size="small"
             border
             no-data-text="暫無數據"
             :columns="table.column"
             :data="table.data"
             @on-selection-change="handleSelectionChange">
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">

            <div class="pg-btn style2" @click="handleViewWuliu(index)">物流路徑</div>
            <div class="pg-btn style1" @click="handleViewRemark(index)">備註</div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共 {{ totalCount }} 條記錄</div>
            <span class="total-price">應收款金額：{{ sums }}</span>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select v-model="curPageSize" size="small" placeholder="數量"
                        @on-change="handlePageSizeChange">
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                       @on-enter="handlePageEnter"/>
              </div>

              <Page size="small"
                    :current="pageIndex"
                    :page-size="curPageSize"
                    :total="totalCount"
                    @on-change="handlePageChange">
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Store from '../../../assets/js/store.js'

let isthis;
export default {
  data() {
    return {
      pageIndex: 1,   //页码
      curPageSize: 10,    //一页数量
      totalCount: 1, //总条数
      pageInput: '',  //输入的页码
      pickAddress: [],
      form: {
        arrive: 132, //提货柜点id Store.fetch().store_id
        start_time: '',
        end_time: '',
        odd_numbers: '',
        phone: '',
        sack_number: '',    //袋号
        username: '',    //用户名称
        pay_type: ''
      },
      sums: 0,
      isSubmiting: false,
      table: {
        column: [
          {
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            minWidth: 150,
            fixed: 'left'
          },
          {
            title: '取貨櫃點',
            key: 'receivingName',
            align: 'center',
            sortable: true,
            minWidth: 150
          },
          {
            title: '客戶名稱【積分】',
            key: 'recipient_contacts',
            align: 'center',
            sortable: true,
            minWidth: 130
          },
          {
            title: '客戶電話',
            key: 'recipient_phone',
            align: 'center',
            sortable: true,
            minWidth: 130
          },
          {
            title: '出貨單號',
            key: 'odd_numbers',
            align: 'center',
            sortable: true,
            minWidth: 150,
          },
          {
            title: '重量',
            key: 'weight',
            align: 'center',
            minWidth: 50,
            sortable: true
          },
          {
            title: '合計費用',
            key: 'sum',
            align: 'center',
            sortable: true,
            minWidth: 70,
            // className: 'demo-table-info-cell-name'
          },
          // {
          //     title: '新/舊',
          //     key: 'order_type',
          //     align: 'center',
          //     minWidth: 70
          // },
          // {
          //     title: '一/二次支付',
          //     key: 'order_online',
          //     align: 'center',
          //     minWidth: 80
          // },
          // {
          //     title: '付款狀況',
          //     key: 'pay_type',
          //     align: 'center',
          //     minWidth: 130,
          //     sortable: true
          // },
          // {
          //     title: '付款狀況',
          //     key: 'pay_status',
          //     align: 'center',
          //     minWidth: 130,
          //     sortable: true
          // },
          // {
          //     title: '泡重',
          //     key: 'volume_weight',
          //     align: 'center',
          //     minWidth: 50,
          //     sortable: true
          // },

          {
            title: '到付運費',
            key: 'freight_collect',
            align: 'center',
            sortable: true,
            minWidth: 60,
            // className: 'demo-table-info-cell-name'
          },
          {
            title: '加收附加費',
            key: 'surcharge_price',
            align: 'center',
            sortable: true,
            minWidth: 60,
            // className: 'demo-table-info-cell-name'
          },
          {
            title: '超期費',
            key: 'outtimepay',
            align: 'center',
            sortable: true,
            minWidth: 60,
            // className: 'demo-table-info-cell-name'
          },
          {
            title: '代收費',
            key: 'amount',
            align: 'center',
            sortable: true,
            minWidth: 60,
            // className: 'demo-table-info-cell-name'
          },
          // {
          // title: '門店立減費',
          // key: 'activity',
          // align: 'center',
          // sortable: true,
          // minWidth: 60,
          // className: 'demo-table-info-cell-name'
          // },
          // {
          //     title: '會員積分(支付)',
          //     key: 'credit',
          //     align: 'center',
          // 	   sortable: true,
          //     minWidth: 60,
          // 	className: 'demo-table-info-column'
          // },
          // {
          //     title: '現金(支付)',
          //     key: 'cash',
          //     align: 'center',
          // 	   sortable: true,
          //     minWidth: 60,
          // 	className: 'demo-table-info-column'
          // },
          // {
          //     title: '澳門通(支付)',
          //     key: 'macaupass',
          //     align: 'center',
          //     minWidth: 50,
          // 	className: 'demo-table-info-column'
          // },
          // {
          //     title: 'Mpay(支付)',
          //     key: 'mpay',
          //     align: 'center',
          // 	sortable: true,
          //     minWidth: 50,
          // 	className: 'demo-table-info-column'
          // },
          // {
          //     title: '支付寶(支付)',
          //     key: 'alipay',
          //     align: 'center',
          // 	sortable: true,
          //     minWidth: 50,
          // 	className: 'demo-table-info-column'
          // },
          // {
          //     title: '中銀二維碼(支付)',
          //     key: 'zyPos',
          //     align: 'center',
          // 	sortable: true,
          //     minWidth: 60,
          // 	className: 'demo-table-info-column'
          // },
          // {
          //     title: '工商POS(支付)',
          //     key: 'icbc',
          //     align: 'center',
          // 	sortable: true,
          //     minWidth: 50,
          // 	className: 'demo-table-info-column'
          // },
          // {
          //     title: '微信(支付)',
          //     key: 'wxpay',
          //     align: 'center',
          // 	   sortable: true,
          //     minWidth: 50,
          // 	   className: 'demo-table-info-column'
          // },
          // {
          //      title: '袋號',
          //      key: 'sack_number',
          //      align: 'center',
          //      sortable: true,
          //      minWidth: 130
          // },
          // {
          //      title: '貨架號',
          //      key: 'shelves',
          //      align: 'center',
          //      sortable: true,
          //      minWidth: 130
          // },
          // {
          //      title: '品名',
          //      key: 'productName',
          //      align: 'center',
          //      sortable: true,
          //      minWidth: 130,
          // },
          // {
          //     title: '簽收時間',
          //     key: 'pick_time',
          //     align: 'center',
          //     sortable: true,
          //     minWidth: 160
          // },
          // {
          //     title: '最新貨態',
          //     key: 'logistics',
          //     align: 'center',
          //     minWidth: 200
          // },

          // {
          //     title: '積分(支付)',
          //     key: 'credit',
          //     align: 'center',
          //     sortable: true,
          //     minWidth: 60,
          //  className: 'demo-table-info-column'
          // },
          // {
          //     title: '現金(支付)',
          //     key: 'cash',
          //     align: 'center',
          //     sortable: true,
          //     minWidth: 60,
          //     className: 'demo-table-info-column'
          // },
          // {
          //     title: '中銀二維碼(支付)',
          //     key: 'zyPos',
          //     align: 'center',
          //     sortable: true,
          //     minWidth: 60,
          //     className: 'demo-table-info-column'
          // },

          {
            title: '代收費支付類型',
            key: 'orderamount_sum',
            align: 'center',
            sortable: true,
            minWidth: 60,
            // className: 'demo-table-info-column'
          },
          {
            title: '送貨上門費',
            key: 'delivery_price',
            align: 'center',
            sortable: true,
            minWidth: 60,
            className: 'demo-table-info-column'
          },
          {
            title: '送貨上門支付類型',
            key: 'delivery_type',
            align: 'center',
            sortable: true,
            minWidth: 80,
            className: 'demo-table-info-column'
          },
          {
            title: '備註',
            key: 'remarks',
            align: 'center',
            sortable: true,
            minWidth: 120
          }
        ],
        data: []
      },
    };
  },
  created() {
    isthis = this;
  },
  mounted() {
    this.getPickAddress();
    this.getList();
  },
  activated() {
    isthis = this;
    this.getPickAddress();
    this.getList();
  },
  methods: {
    handleViewWuliu(index) {
      let tableData = this.table.data;
      this.$router.push({path: '/shopSignedlogisticsInfo?orderNo=' + tableData[index].odd_numbers});
    },
    handleViewRemark(index) {
      let tableData = this.table.data;
      this.$router.push({path: '/shopSignedRemark?id=' + tableData[index].id});
    },
    //提貨櫃點
    getPickAddress() //提貨櫃點
    {
      this.$Rq.requestAuth({
        url: this.$Api.deliveryListToShop,
        method: 'post'
      }).then((res) => {
        if (res.code == 0) {
          this.pickAddress = res.data;

          if (res.data.length > 0) {
            this.form.arrive = res.data[0].ReceivingID;
          }
        }
      });
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq.requestAuth({
        url: this.$Api.scanIn,
        method: 'get',
        data: {
          status: 4, //未签收3，已签收4
          offset: (this.pageIndex - 1) * this.curPageSize,
          limit: this.curPageSize,
          arrive: form.arrive,
          start_time: this.formatDate(form.start_time),
          end_time: this.formatDate(form.end_time),
          odd_numbers: form.odd_numbers,
          phone: form.phone,
          sack_number: form.sack_number,
          username: form.username,
          pay_type: form.pay_type
        }
      }).then((res) => {
        this.isSubmiting = false;
        if (res.code == 0) {
          let tempArr = [];
          let class_pay_type = [];
          let resData = res.data.data;

          for (let i = 0; i < resData.length; i++) {
            let integral_tw = 0;
            let orderamount_additional_fee;
            let orderamount_credit;
            let orderamount_cash;
            let orderamount_alipay;
            let orderamount_macaupass;
            let orderamount_mpay;
            let orderamount_zyPos;
            let orderamount_icbc;
            let orderamount_wxpay;
            let orderamount_overtime_fee;
            let order_type;
            let order_online;
            let delivery_type;

            for (let j = 0; j < resData[i].user.tw.length; j++) {
              let integral_tw_count = Number(resData[i].user.tw[j].integral);
              integral_tw += integral_tw_count;
            }

            if (resData[i].pay_status == 0) {
              resData[i].pay_status = '未付款';

            } else {

              if (resData[i].orderamount != null) {
                if (resData[i].orderamount.delivery == null) {
                  resData[i].pay_status = '已付款';
                } else {
                  resData[i].pay_status = '已付款(含上門費)';
                }
              } else {
                resData[i].pay_status = '未付款';
              }
            }

            if (resData[i].pay_type == 0) {
              class_pay_type[i] = '';
            } else {
              class_pay_type[i] = 'demo-table-app-row';
            }

            if (resData[i].orderamount != null) {

              order_type = '新';

              if (resData[i].orderamount.additional_fee == 0 || resData[i].orderamount.additional_fee == null) {
                orderamount_additional_fee = 0;
              } else {
                orderamount_additional_fee = resData[i].orderamount.additional_fee;
              }

              if (resData[i].orderamount.overtime_fee == 0 || resData[i].orderamount.overtime_fee == null) {
                orderamount_overtime_fee = 0;
              } else {
                orderamount_overtime_fee = resData[i].orderamount.overtime_fee;
              }

              if (resData[i].orderamount.order_online == 1) { //積分

                order_online = '二次/積分';

                if (resData[i].orderamount.credit == null) {
                  orderamount_credit = Number(resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_credit = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_icbc = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount.order_online == 2) { //中銀

                order_online = '二次/中銀';

                if (resData[i].orderamount.boc == null) {
                  orderamount_zyPos = Number(resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_zyPos = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.boc);
                }

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc);
                } else {
                  orderamount_icbc = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount.order_online == 3) { //工銀

                order_online = '二次/工銀';

                if (resData[i].orderamount.icbc == null) {
                  orderamount_icbc = Number(resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_icbc = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.icbc);
                }

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount.order_online == 4) { //微信

                order_online = '二次/微信';

                if (resData[i].orderamount.wechat == null) {
                  orderamount_wxpay = Number(resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_wxpay = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.wechat);
                }

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc);
                } else {
                  orderamount_icbc = 0;
                }
              }

              if (resData[i].orderamount.order_online == 5) { //Mpay

                order_online = '二次/Mpay';

                if (resData[i].orderamount.mpay == null) {
                  orderamount_mpay = Number(resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_mpay = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.mpay);
                }

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc);
                } else {
                  orderamount_icbc = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount.order_online == 6) { //澳門通
                order_online = '二次/澳門通';

                if (resData[i].orderamount.macaupass == null) {
                  orderamount_macaupass = Number(resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_macaupass = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.macaupass);
                }

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc);
                } else {
                  orderamount_icbc = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount.order_online == 7) { //Alipay

                order_online = '二次/支付寶';

                if (resData[i].orderamount.alipay == null) {
                  orderamount_alipay = Number(resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_alipay = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.alipay);
                }

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc);
                } else {
                  orderamount_icbc = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount.order_online == 8) { //現金

                order_online = '二次/現金';

                orderamount_cash = Number(resData[i].orderamount.overtime_fee + resData[i].orderamount.cash);

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc);
                } else {
                  orderamount_icbc = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount.order_online == null || resData[i].orderamount.order_online == 0) //NULL
              {
                order_online = '一次';

                if (Number(resData[i].orderamount.credit + resData[i].orderamount.credit_tw) > 0) {
                  orderamount_credit = Number(resData[i].orderamount.credit) + Number(resData[i].orderamount.credit_tw + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_credit = 0;
                }

                if (resData[i].orderamount.cash > 0) {
                  orderamount_cash = Number(resData[i].orderamount.cash + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_cash = 0;
                }

                if (resData[i].orderamount.alipay > 0) {
                  orderamount_alipay = Number(resData[i].orderamount.alipay + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_alipay = 0;
                }

                if (resData[i].orderamount.macaupay > 0) {
                  orderamount_macaupass = Number(resData[i].orderamount.macaupay + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_macaupass = 0;
                }

                if (resData[i].orderamount.mpay > 0) {
                  orderamount_mpay = Number(resData[i].orderamount.mpay + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_mpay = 0;
                }

                if (resData[i].orderamount.boc > 0) {
                  orderamount_zyPos = Number(resData[i].orderamount.boc + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_zyPos = 0;
                }

                if (resData[i].orderamount.icbc > 0) {
                  orderamount_icbc = Number(resData[i].orderamount.icbc + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_icbc = 0;
                }

                if (resData[i].orderamount.wechat > 0) {
                  orderamount_wxpay = Number(resData[i].orderamount.wechat + resData[i].orderamount.overtime_fee);
                } else {
                  orderamount_wxpay = 0;
                }
              }

              if (resData[i].orderamount != null && resData[i].orderamount.delivery_type == 1) {
                delivery_type = '積分';
              } else if (resData[i].orderamount != null && resData[i].orderamount.delivery_type == 2) {
                delivery_type = '中銀二維碼';
              } else if (resData[i].orderamount != null && resData[i].orderamount.delivery_type == 8) {
                delivery_type = '現金';
              } else {
                delivery_type = '- - -';
              }

              let orderamount_sum;
              if (orderamount_zyPos != 0 && orderamount_cash == 0 && orderamount_credit == 0) {
                orderamount_sum = '中銀';
              }
              if (orderamount_zyPos == 0 && orderamount_cash != 0 && orderamount_credit == 0) {
                orderamount_sum = '現金';
              }
              if (orderamount_zyPos == 0 && orderamount_cash == 0 && orderamount_credit != 0) {
                orderamount_sum = '積分';
              }

              tempArr.push({

                id: resData[i].id,

                recipient_contacts: resData[i].recipient_contacts + '【' + (resData[i].user.user_integral + integral_tw) + '】', //客戶名稱【積分】

                recipient_phone: resData[i].recipient_phone, //客戶電話

                productName: resData[i].detailed.name, //品名

                odd_numbers: resData[i].odd_numbers, //出貨單號

                sack_number: resData[i].sack_number, //袋號

                receivingName: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName, //取貨櫃點

                shelves: resData[i].shelves == null ? '- - -' : resData[i].shelves.code, //貨架號

                pay_status: resData[i].pay_status, //付款状况

                pick_time: resData[i].pick_time, // 簽收時間

                freight_collect: Number(resData[i].freight_collect), // 代收费和合计

                surcharge_price: resData[i].orderamount.additional_fee ? resData[i].orderamount.additional_fee : 0, // 附加費

                delivery_price: resData[i].orderamount == null ? '0' : resData[i].orderamount.delivery, // 送貨上門費

                delivery_type: delivery_type, // 送貨上門費支付類型

                amount: Number(resData[i].amount), // 代收費

                sum: resData[i].orderamount.allamount ? resData[i].orderamount.allamount : 0,

                outtimepay: resData[i].orderamount.overtime_fee ? resData[i].orderamount.overtime_fee : 0, //超期費

                activity: resData[i].orderamount.discount == 0 ? '無立減' : '-' + resData[i].orderamount.discount, // 立減3元

                remarks: resData[i].remarks, // 備註

                additional_fee: orderamount_additional_fee, // 附加費

                credit: orderamount_credit, //已簽收-積分

                cash: orderamount_cash, //已簽收-現金

                alipay: orderamount_alipay, //已簽收-支付寶

                macaupass: orderamount_macaupass, //已簽收-澳門通

                mpay: orderamount_mpay, //已簽收-澳門錢包

                zyPos: orderamount_zyPos, //已簽收-中銀

                icbc: orderamount_icbc, //已簽收-工銀

                wxpay: orderamount_wxpay, //已簽收-微信

                orderamount_sum: orderamount_sum,

                order_type: order_type, //新或舊

                order_online: order_online,

                weight: resData[i].weight, //重量

                volume_weight: resData[i].volume_weight, //泡重

                pay_type: resData[i].pay_type == 0 ? '未在APP內付款' : '已在APP內付款', //付款状况
              });
            } else {
              order_type = '舊';

              if (resData[i].orderamount != null && resData[i].orderamount.delivery_type == 1) {
                delivery_type = '積分';
              } else if (resData[i].orderamount != null && resData[i].orderamount.delivery_type == 2) {
                delivery_type = '中銀二維碼';
              } else if (resData[i].orderamount != null && resData[i].orderamount.delivery_type == 8) {
                delivery_type = '現金';
              } else {
                delivery_type = '- - -';
              }

              let orderamount_sum;

              if (resData[i].zyPos != null && resData[i].cash == null && resData[i].credit == null) {
                orderamount_sum = '中銀';
              }
              if (resData[i].zyPos == null && resData[i].cash != null && resData[i].credit == null) {
                orderamount_sum = '現金';
              }
              if (resData[i].zyPos == null && resData[i].cash == null && resData[i].credit != null) {
                orderamount_sum = '積分';
              }

              tempArr.push({

                id: resData[i].id,

                recipient_contacts: resData[i].recipient_contacts + '【' + (resData[i].user.user_integral + integral_tw) + '】', //客戶名稱【積分】

                recipient_phone: resData[i].recipient_phone, //客戶電話

                productName: resData[i].detailed.name, //品名

                odd_numbers: resData[i].odd_numbers, //出貨單號

                sack_number: resData[i].sack_number, //袋號

                receivingName: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName, //取貨櫃點

                shelves: resData[i].shelves == null ? '- - -' : resData[i].shelves.code, //貨架號

                pay_status: resData[i].pay_status, //付款状况

                pick_time: resData[i].pick_time, // 簽收時間

                freight_collect: Number(resData[i].freight_collect), // 代收费和合计

                surcharge_price: Number(resData[i].surcharge_price), // 附加费

                delivery_price: resData[i].orderamount == null ? '0' : resData[i].orderamount.delivery, // 送貨上門費

                delivery_type: delivery_type, // 送貨上門費支付類型

                amount: Number(resData[i].amount), // 代收費

                sum: Number(resData[i].freight_collect) + Number(resData[i].surcharge_price) + Number(resData[i].amount) + Number(resData[i].outtimepay), //合計費用

                outtimepay: resData[i].outtimepay ? resData[i].outtimepay : 0, //超期費

                activity: resData[i].store == null ? '0' : '-' + resData[i].store.activity, // 立減3元

                remarks: resData[i].remarks, // 備註

                credit: resData[i].credit ? resData[i].credit : 0,

                cash: resData[i].cash ? resData[i].cash : 0,

                alipay: resData[i].alipay ? resData[i].alipay : 0,

                macaupass: resData[i].macaupass ? resData[i].macaupass : 0,

                mpay: resData[i].mpay ? resData[i].mpay : 0,

                zyPos: resData[i].zyPos ? resData[i].zyPos : 0,

                icbc: resData[i].icbc ? resData[i].icbc : 0,

                wxpay: resData[i].wxpay ? resData[i].wxpay : 0,

                // orderamount_sum: Number(resData[i].zyPos ? resData[i].zyPos : 0) + Number(resData[i].cash ? resData[i].cash : 0) + Number(resData[i].credit ? resData[i].credit : 0),

                orderamount_sum: orderamount_sum,

                order_type: order_type,

                weight: resData[i].weight, //重量

                volume_weight: resData[i].volume_weight, //泡重

                order_online: '舊'
              });
            }
          }

          this.totalCount = res.data.count;
          this.table.data = tempArr;
        } else {
          this.showTipInfo(res.msg);
        }
      }).catch((err) => {
        this.isSubmiting = false;
      });
    },
    handleSearch() {
      this.pageIndex = 1;
      isthis.sums = 0;
      this.getList();
    },
    formatDate(datetime) {
      if (!datetime) return '';
      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
    },
    formatNum(num) {
      return num < 10 ? '0' + num : num;
    },
    handleExport() {
      let token = localStorage.getItem('jyb_token');
      let form = this.form;
      let params = {
        'Authorization': token,
        status: 4,
        arrive: form.arrive,
        odd_numbers: form.odd_numbers,
        sack_number: form.sack_number,
        phone: form.phone,
        username: form.username,
        start_time: this.formatDate(form.start_time),
        end_time: this.formatDate(form.end_time)
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);
      if (form.start_time == '') {
        this.$Utils.showTipInfo("請選擇起始時間");
      } else if (form.end_time == '') {
        this.$Utils.showTipInfo("請選擇结束時間");
      } else {
        this.getList();
        window.open(`${this.$Api.deliverExport_old}?${formatParams}`, '_blank');
      }
    },
    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      isthis.sums = 0;
      this.getList();
    },

    handlePageInput() {
      let value = ('' + this.pageInput).replace(/\D/g, '');
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      isthis.sums = 0;
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      isthis.sums = 0;
      this.getList();
    },

    handlePageChange(value) {
      this.pageIndex = value;
      isthis.sums = 0;
      this.getList();
    },
    // 多选 勾选  显示总金额
    /*handleSelectionChange() {
      let sums = 0;
      this.curCheckedList = this.$refs.table.getSelection();
      this.curCheckedList.forEach((item => {
        sums += item.sum
      }))
      isthis.sums = Math.floor(sums);
    },*/
    handleSelectionChange() {
      let sums = 0;
      this.curCheckedList = this.$refs.table.getSelection();
      this.curCheckedList.forEach((item => {
        if (item.pay_type == '未在APP內付款') {
          sums += item.sum
        } else {
          sums += item.outtimepay
        }
      }))

      isthis.sums = Math.floor(sums)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "deliverSigned.scss";
</style>
<style>
.ivu-table td.demo-table-info-column {
  background-color: #FFEBDE;
  color: #000;
}

.ivu-table td.demo-table-info-cell-name {
  background-color: #D6E7FF;
  color: #000;
}
</style>